import { DatePicker, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
import { ColumnChart, FilterBar } from "./chartUtils";
dayjs.extend(customParseFormat);

const { Option } = Select;

function AssigneeAvgTimeLog({ projects }) {
    const [assignee, setAssignee] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(dayjs());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [formData, setFormData] = useState({
        assignee_id: "",
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
    });

    const {
        status,
        data: assigneeRes,
        refetch: fetchAssignee,
    } = useQuery(
        "assignee",
        async () => await HTTP("/analytics/getJiraAssignees", { staff_id }),
        { enabled: false },
    );

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "assigneeAvgWorkLog",
        async () =>
            await HTTP("/analytics/getJiraAvgTimingByMonth", { ...formData }),
        { enabled: false },
    );

    useEffect(() => {
        if (status === "success") setAssignee(assigneeRes.data);
        if (columnChartStatus === "success")
            setColumnChartData(columnChartDataRes.data);
    }, [status, columnChartStatus, columnChartDataRes]);

    useEffect(() => {
        fetchAssignee();
        refetch();
    }, []);
    useEffect(() => {
        refetch();
    }, [formData]);

    function handleYearChange(_, dateString) {
        setDefaultYear(dateString === "" ? dayjs() : dayjs(dateString));
        setFormData((prev) => ({
            ...prev,
            range_year: dateString || dayjs().get("year"),
        }));
    }

    function handleProjectSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            project_id: e ? e.split("#")[0] : -1,
        }));
    }

    function handleAssigneeSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            assignee_id: e ? e.split("#")[0] : "",
        }));
    }

    const isReady =
        columnChartStatus !== "loading" && columnChartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <DatePicker
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    style={{ width: 120 }}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Assignee"
                    onChange={handleAssigneeSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && columnChartData.length > 0 ? (
                <ColumnChart rawData={columnChartData} height={420} />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default AssigneeAvgTimeLog;
